<span class="relative flex flex-col w-full h-full">
    <div class="p-8 pb-6" mat-dialog-content>
        <ng-container>
            <div class="sm:flex xs:block w-100 border-b pb-[10px]">
                <!-- Avatar and actions -->
                <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-30pr items-center max-w-[200px]"></div>

                <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-70pr w-full min-w-0">
                    <!-- Header -->
                    <div class="flex items-start justify-between gap-3 sm:ml-[20px] py-2">
                        <div class="min-w-0 flex-1">
                            <div
                                class="font-bold leading-tight truncate text-xl sm:text-3xl md:text-4xl"
                                [matTooltip]="data.user?.username"
                            >
                                {{ data.user?.username }}
                            </div>
                        </div>

                        <button type="button" (click)="dialogCloseMessage()" mat-icon-button class="shrink-0 self-start">
                            <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="float-left w-[100%] mt-4">
                <div class="space-y-4">
                    @if (data.user?.domainName) {
                    <div class="flex sm:items-center">
                        <mat-icon [svgIcon]="'heroicons_outline:office-building'"></mat-icon>
                        <div class="ml-6 leading-6">{{ data.user?.username }}</div>
                    </div>
                    } @if (data.user?.expiryDate) {
                    <div class="flex sm:items-center">
                        <mat-icon [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                        <div class="ml-6 leading-6">{{ formatDate(data.user?.expiryDate) }}</div>
                    </div>
                    }
                </div>
            </div>
            <form
                [formGroup]="form"
                #profileInNgForm="ngForm"
                (keyup.enter)="save()"
                class="float-left w-[100%] mt-5 mb-1 pb-2"
                autocomplete="off"
            >
                <div class="ml-0.5 font-medium text-secondary mb-[10px]">{{ 'label_password' | translate }}</div>
                <div class="float-left w-100 border-t pt-[10px] mb-4">
                    <mat-accordion class="mat-accordion">
                        <mat-expansion-panel class="mat-expansion-adgangur">
                            <mat-expansion-panel-header>
                                <mat-panel-title> {{ 'label_new_password' | translate }} </mat-panel-title>
                            </mat-expansion-panel-header>

                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <input
                                    formControlName="newPassword"
                                    type="password"
                                    autocomplete="new-password"
                                    matInput
                                    name="newPassword"
                                />
                            </mat-form-field>
                            @if (form.get('newPassword').hasError('minlength')) {
                            <mat-error> {{'error_new_password_length' | translate: { passwordMinLength: passwordMinLength } }} </mat-error>
                            }
                            <div class="float-left w-100 border-t pt-[10px] mb-4 mat-expansion-adgangur">
                                <span class="mat-expansion-panel-header-title mb-2 mt-2"> {{ 'label_confirm_password' | translate }} </span>
                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                    <input
                                        formControlName="confirmPassword"
                                        type="password"
                                        autocomplete="new-password"
                                        matInput
                                        name="newPasswordConfirm"
                                    />
                                </mat-form-field>
                                @if (form.get('confirmPassword').hasError('required') && (form.get('confirmPassword').dirty ||
                                form.get('confirmPassword').touched)) {
                                <mat-error> {{'error_confirm_password' | translate }} </mat-error>
                                } @if (form.get('confirmPassword').hasError('mustMatch') && (form.get('confirmPassword').dirty ||
                                form.get('confirmPassword').touched)) {
                                <mat-error> {{'error_password_match' | translate }} </mat-error>
                                }
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>

                <div class="ml-0.5 font-medium text-secondary mb-[10px]">{{ 'label_access_role' | translatePlural }}</div>
                <div class="float-left w-100 border-t pt-[10px] mb-none">
                    <div class="space-y-2">
                        <mat-accordion class="mat-accordion">
                            @for (group of data.roleGroups; track group; let isFirst = $first) {
                            <mat-expansion-panel class="mat-expansion-adgangur" [expanded]="isFirst">
                                <mat-expansion-panel-header>
                                    <mat-panel-title> {{ 'label_role_group_' + group.roleGroupName | transloco }} </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="grid grid-cols-4 gap-2 w-full mt-1 mb-2 mat-expansion-adgangur">
                                    @for (role of rolesGroupMap[group.roleGroupId]; track role) {
                                    <div class="col-span-4">
                                        <div class="flex items-center justify-between">
                                            <div class="flex-auto cursor-pointer">
                                                <div class="leading-6 font-medium">{{ 'label_role_' + role.roleName | transloco }}</div>
                                                <div class="text-md text-secondary">{{ 'info_role_' + role.roleName | transloco }}</div>
                                            </div>
                                            <mat-slide-toggle
                                                class="ml-2"
                                                [color]="'primary'"
                                                [formControlName]="role.roleName"
                                                [checked]="useDefault"
                                            >
                                            </mat-slide-toggle>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </mat-expansion-panel>
                            }
                        </mat-accordion>
                    </div>
                </div>
            </form>
            <div class="float-left w-100 pb-4 sm:pb-2 text-right">
                <div class="flex items-center justify-end mt-1">
                    @if (form.dirty) {
                    <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                        {{ 'label_cancel' | translate }}
                    </button>
                    }
                    <button class="ml-4" (click)="save()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                        @if (formEnabled) {
                        <span> {{ 'label_save' | translate }} </span>
                        } @if (!formEnabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</span>
